export const ORIGINAL_PATH = 'original_path';
export const QAP_COOKIE = 'QAP';
export const FORBIDDEN_PATH = '/forbidden';
export const LOGOUT_PATH = '/logout';
export const UNAUTHORIZED_PATH = '/unauthorized';
export const LOGOUT_BROADCAST_EVENT = 'logout';
export const STATIC_ROUTES = '/static';
export const EQAT_OIDC_CALLBACK_PATH = '/eqat/callback';
